import { Context } from '../../../context';
import { useContext } from 'react';

const getAuthHeaders = (headers = {}) => {
  const requestHeaders = new Headers(headers);
  const token = localStorage.getItem('token');

  if (token && !requestHeaders.has('Authorization')) {
    requestHeaders.set('Authorization', `Bearer ${token}`);
  }

  return requestHeaders;
};

export const apiFetch = async (url, options = {}) => {
  const response = await fetch(url, {
    ...options,
    headers: getAuthHeaders(options.headers),
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));

    const error = new Error(body.message || 'Something went wrong');
    error.status = response.status;

    throw error;
  }

  return response;
};

export const useError = () => {
  const context = useContext(Context);
  const checkError = (errorOrStatus) => {
    const code =
      typeof errorOrStatus === 'number' ? errorOrStatus : errorOrStatus?.status;
    if (code === 401) {
      context.logout();
    }
  };
  return { checkError };
};
